<script setup>
import {computed} from 'vue'
import {
  ChevronDown,
  ChevronRight,
  ChevronLeft,
  ConciergeBell,
  CircleCheck,
  CircleX,
  Eye,
  FileText,
  HandCoins,
  HandPlatter,
  HeartHandshake,
  Home,
  IdCardLanyard,
  Inbox,
  Info,
  LayoutDashboard,
  LayoutGrid,
  List,
  LogOut,
  Mail,
  Menu,
  MessageCircleQuestionMark,
  MessageSquareMore,
  Moon,
  Paperclip,
  Plus,
  RefreshCw,
  Signature,
  Settings,
  Sun,
  SquareArrowOutUpRight,
  ThumbsDown,
  ThumbsUp,
  Trash2,
  User,
  Users,
  Wrench,
  X
} from 'lucide-vue-next'

const icons = {
  ChevronDown,
  ChevronRight,
  ChevronLeft,
  ConciergeBell,
  CircleCheck,
  CircleX,
  Eye,
  FileText,
  HandCoins,
  HandPlatter,
  HeartHandshake,
  Home,
  IdCardLanyard,
  Inbox,
  Info,
  LayoutDashboard,
  LayoutGrid,
  List,
  LogOut,
  Mail,
  Menu,
  MessageCircleQuestionMark,
  MessageSquareMore,
  Moon,
  Paperclip,
  Plus,
  RefreshCw,
  Signature,
  Settings,
  Sun,
  SquareArrowOutUpRight,
  ThumbsDown,
  ThumbsUp,
  Trash2,
  User,
  Users,
  Wrench,
  X
}

const props = defineProps({
  name: {type: String, required: true},
  size: {type: [Number, String], default: 20},
  color: {type: String, default: 'currentColor'},
  class: {type: [String, Array, Object], default: ''}, // ✅ allow Tailwind classes
  spin: {type: Boolean, default: false}
})

const Icon = computed(() => icons[props.name] || null)
</script>

<template>
  <component
      v-if="Icon"
      :is="Icon"
      :size="size"
      :color="color"
      :class="['align-middle', props.class, { 'spin-animation': spin }]"
  />
</template>

<style scoped>
@keyframes spinClockwise {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.spin-animation {
  animation: spinClockwise 1s linear infinite;
}
</style>
